import BaseModel from './BaseModel';

export default class markupBundle extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.name = data.name || undefined;
        this.countRatePlan = data.countRatePlan || undefined;
        this.stayDateFrom = data.stayDateFrom || undefined;
        this.stayDateTo = data.stayDateTo || undefined;
        this.productType = data.productType || undefined;
        this.countBookDate = data.countBookDate || undefined;
        this.markupType = data.markupType || 0;
        this.markupValue = data.markupValue || undefined;
        this.bookDates = data.bookDates || undefined;
        this.isActived = data.isActived || false;
        this.createdBy = data.createdBy || undefined;
        this.updateBy = data.updateBy || undefined;
        this.bookDates = data.bookDates || [];
        this.ratePlanConfigs = data.ratePlanConfigs || undefined;
        this.markupFlightValue = data.markupFlightValue === 0 ? 0 : data.markupFlightValue || undefined;
        this.typeOfMultipleRoom = data.typeOfMultipleRoom || 'NumberOfRoom';
    }

    export() {
        const result = super.export({
            id: this.id,
            name: this.name,
            stayDateFrom: this.stayDateFrom.utcOffset(0, true).format(),
            stayDateTo: this.stayDateTo.utcOffset(0, true).format(),
            productType: this.productType || 2,
            markupType: this.markupType,
            markupValue: parseInt(this.markupValue),
            bookDates: this.bookDates.map(item => ({ ...item, markupValue: parseInt(item.markupValue) })),
            ratePlanConfigs: this.ratePlanConfigs,
            isActived: this.isActived,
            markupFlightValue: parseInt(this.markupFlightValue),
            typeOfMultipleRoom: this.typeOfMultipleRoom,
        });
        return result;
    }
}
